import { Component, PLATFORM_ID, Inject, OnInit } from '@angular/core';
// import { isPlatformBrowser } from '@angular/common';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { map, delay, withLatestFrom } from 'rxjs/operators';
import { ChatErrorService } from './shared/services/chat-error.service';
import { SocketService } from './shared/services/socket.service';
import { MessageSocketService } from './shared/services/message-socket.service';
import { ChatApiCallService } from './shared/services/chat-api-call.service';
import { AuthService } from './shared/services/auth.service';
// import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss', '../styles/snackbar.scss']
})

export class AppComponent implements OnInit {

  // For Progressbar
  // loaders = this.loader.progress$.pipe(
  //   delay(1000),
  //   withLatestFrom(this.loader.progress$),
  //   map(v => v[1]),
  // );
  loaders: any

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private loader: LoadingBarService,
    // private chatCommonService: ChatCommonService,
    private mss: MessageSocketService,
    private chatErrorService: ChatErrorService,
    private ioClient: SocketService,
    private apiCallService: ChatApiCallService,
    private authService: AuthService,
  ) {
    // if (isPlatformBrowser(this.platformId)) {
    //   translate.setDefaultLang('en');
    //   translate.addLangs(['en', 'de', 'es', 'fr', 'pt', 'cn', 'ae']);
    // }
    localStorage.setItem('setItem', 'true')
    this.loaders = this.loader.progress$.pipe(
      delay(1000),
      withLatestFrom(this.loader.progress$),
      map(v => v[1]),
    );
  }

  onClick(event: Event) {
    // this.chatErrorService.onToastClick(event, this.chatCommonService)
  }

  async ngOnInit() {
    if (await this.ioClient.getToken()) {
      this.ioClient.connectSocket().then((res) => {
        this.mss?.initEvents();
        console.log("connected to socket res", res);
      });
    }
  }


}
